import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let EditFloorComponent = {
    selector: "vcEditFloor",
    templateUrl: "/angular/components/building/edit-floor.component.html",
    bindings: {
        hids: "=",
    },
    controller: class EditFloorController {
        public accessType: string | number;
        private dialog: DialogUtils;
        private floor: String;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {}

        confirm(): void {
            this.dialog.hide(this.floor);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("building")
    .component(EditFloorComponent.selector, EditFloorComponent);
